module.exports = __webpack_public_path__ + "img/image5.c3eb25af.png";